import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr, ToastrModule } from 'ngx-toastr';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';

// import {
//   NgxMatDatetimePickerModule,
//   NgxMatNativeDateModule,
//   NgxMatTimepickerModule
// } from '@angular-material-components/datetime-picker';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top'
    })),
    provideHttpClient(),
    provideAnimationsAsync(),
provideToastr({
  // positionClass: 'toast-top-right',  // 👈 fixed to bottom-right viewport
  // timeOut: 3000,
  // progressBar: true,
  // closeButton: true,
  // preventDuplicates: true,
}),

    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
     // ToastrModule.forRoot(),
      NgxPaginationModule,
      MatDatepickerModule,
      MatInputModule,
      MatFormFieldModule,
      MatNativeDateModule
      // NgxMatDatetimePickerModule,
      // NgxMatNativeDateModule,
      // NgxMatTimepickerModule
    ),

    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ]
  
};